import http from "./http_common";

class PatientService {
  queryString(payload) {
    return Object.keys(payload)
      .map((key) =>
        key &&
          payload[key] !== undefined &&
          payload[key] !== null &&
          payload[key] !== ""
          ? key + "=" + payload[key]
          : ""
      )
      .filter(Boolean)
      .join("&");
  }

  PatientList(payload) {
    const queryString = new URLSearchParams(payload).toString();
    return http.get(`/patient/list/filter?${queryString}`);
  }
  PatientCount(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/patient/patientCountStatus?${queryString}`)
  }

  PatientListFilter(payload) {
    const queryString = Object.entries(payload)
      .filter(
        ([_, value]) => value !== undefined && value !== null && value !== ""
      )
      .map(([key, value]) => `${key}=${value}`)
      .join("&");

    return http.get(`/patient/list/filter?${queryString}`);
  }

  patientActiveInactive(payload) {
    return http.put('/patient/update/status', payload);
  }

  AddPatient(payload) {
    return http.post('/patient/', payload);
  }

  EditPatientData(payload) {
    return http.put(`/patient/${payload.id}`, payload);
  }
  isPermissionGranted(data) {
    const queryString = this.queryString(data);
    return http.get(`/patientHistoryAccess/list/filter?${queryString}`);
  }

  getMyReport(payload) {
    var queryString = Object.keys(payload)
      .map((key) => (key && payload[key]) ? key + "=" + payload[key] : '')
      .join("&");
    return http.get(`patientDocument/list/filter?${queryString}`);
  }

  procedureReqList(data) {
    const queryString = this.queryString(data);
    return http.get(`/procedureRequest/list/filter?${queryString}`);
  }
  procedureReqListCount(data) {
    const queryString = this.queryString(data);
    return http.get(`/procedureRequest/procedureRequestCountStatus?${queryString}`);
  }

  newProcedure(payload) {
    return http.post('/procedureRequest/save', payload);
  }

  updateProcedure(payload) {
    return http.put('/procedureRequest/update', payload);
  }

  patientQueueList(data) {
    const queryString = this.queryString(data);
    return http.get(`/patientAppointment/get/queue/status?${queryString}`);
  }

  patientQrData(payload) {
    const queryString = this.queryString(payload);
    return http.get(`patient/consultation/list/filter?${queryString}`);
  }

  patientInvoiceDetails(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/CartDetails/completedList/filter?${queryString}`);
  }

  patientWatchData(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/webhooks/garmin/list?offset=0&${queryString}`);
  }

  patientMembershipStatus(payload) {
    return http.post('/PatientMembership/planValid', payload);
  }

  GarminRespirationDailyData(payload) {
    const queryString = this.queryString(payload);
    return http.get(`webhooks/garmin/dayWiseList?${queryString}`);
  }

  GarminRespirationWeeklyData(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/webhooks/garmin/weeklyWiseList?${queryString}`);
  }

  patientMembershipDet(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/PatientMembershipServiceDetails/list/filter?${queryString}`);
  }

  prescriptionUpload(payload) {
    return http.post('/RxPrescriptionOrder/', payload);
  }

  GetGarminDevices(payload) {
    return http.get("/webhooks/garmin/list", {
      params: payload,
    });
  }

  saveMedicineReminder(payload){
    return http.post('/patientMedicationReminder/save', payload);
  }

  saveMedicineReminderBatch(payload){
    return http.post('/patientMedicationReminder/batch/save',payload);
  }

  getMedicineReminderList(payload){
    const queryString = this.queryString(payload);
    return http.get(`/patientMedicationReminder/list/filter?${queryString}`);
  }


}

export default new PatientService();
